import React from 'react';
import { Box, Button, Grow, IconButton, Modal, Stack, Typography } from '@mui/material';
import { NewsModalProps } from '../types/index';
import { Close, MenuRight, MenuLeft } from 'mdi-material-ui';
import { createElement, useState, useLayoutEffect, useEffect } from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import styles from './newsModal.module.css';
import { NewsFeedDto } from 'src/models/account';
import { useSettings } from 'src/@core/hooks/useSettings';
import { useGetNewsArticleHtmlByIdQuery } from 'src/queries/services/account';

const NewsModal = ({ open = false, handleClose, newsFeed = [], activeIndex = 0 }: NewsModalProps) => {
  const [displayIndex, setDisplayIndex] = useState<number>(0);
  const [newsItem, setNewsItem] = useState<NewsFeedDto | null>(null);

  const under1200px = useMediaQuery('(max-width:1200px)');
  const { settings, saveSettings } = useSettings();

  const handleForward = () => {
    if (displayIndex < newsFeed.length - 1) {
      setDisplayIndex(prev => prev + 1);
    }
  };

  const previousIsDisabled = displayIndex === 0;
  const nextIsDisabled = displayIndex === newsFeed.length - 1;

  const handlePrevious = () => {
    if (displayIndex > 0) {
      setDisplayIndex(prev => prev - 1);
    }
  };

  const { data } = useGetNewsArticleHtmlByIdQuery(newsItem?.id ?? '', {
    queryKeyOverride: [`newsfeedArticle-${newsItem?.id}`, newsItem?.id],
    enabled: Boolean(newsItem?.id)
  });

  useLayoutEffect(() => {
    setNewsItem(newsFeed[displayIndex]);
  }, [displayIndex, newsFeed]);

  useEffect(() => {
    if (open) {
      // close settings nav bar if it is open
      if (!settings.navCollapsed) {
        saveSettings({ ...settings, navCollapsed: true });
      }
    } else {
      // open settings nav bar if it is closed
      if (settings.navCollapsed) {
        saveSettings({ ...settings, navCollapsed: false });
      }
    }
  }, [open, saveSettings, settings]);

  useEffect(() => {
    setDisplayIndex(activeIndex);
  }, [activeIndex]);

  return (
    <Modal
      key={`${activeIndex}`}
      className={styles.modal}
      open={open}
      onClose={handleClose}
      hideBackdrop
      container={() => document.querySelector('.react-grid-layout')}>
      <Grow in={open} style={{ transformOrigin: '50% 0 0' }}>
        <Stack
          direction="column"
          className={`${styles.modalContent__container} ${
            settings.navCollapsed ? styles.modalContent__container_wide : styles.modalContent__container_narrow
          } ${under1200px ? styles.mobileModal : ''}`}>
          <Box
            className={`${styles.news_header} ${
              newsItem?.internal ? styles.news_header__depot : styles.news_header__network
            }`}>
            <Box className={styles.news_header_category__container}>
              <Typography className={styles.news_header_category}>{`Newsfeed`}</Typography>

              <Stack direction="row" className={styles.news_header_toolBarContainer}>
                {/* <IconButton className={styles.new_header_toolBar_iconButton}>
                  <EmailOutline htmlColor="#626679" />
                </IconButton>
                <IconButton className={styles.new_header_toolBar_iconButton}>
                  <TrayArrowDown htmlColor="#626679" />
                </IconButton>
                <IconButton className={styles.new_header_toolBar_iconButton}>
                  <Printer htmlColor="#626679" />
                </IconButton> */}
                <IconButton
                  className={styles.new_header_toolBar_iconButton}
                  disabled={previousIsDisabled}
                  onClick={handlePrevious}>
                  <MenuLeft htmlColor="#626679" />
                </IconButton>
                <IconButton
                  className={styles.new_header_toolBar_iconButton}
                  disabled={nextIsDisabled}
                  sx={{ ['& .Mui-disabled']: { cursor: 'not-allowed' } }}
                  onClick={handleForward}>
                  <MenuRight htmlColor="#626679" />
                </IconButton>
                <IconButton onClick={handleClose}>
                  <Close htmlColor="#acacac" />
                </IconButton>
              </Stack>
            </Box>

            <Box className={styles.news_header_title__container}>
              <Typography component="h3" className={styles.news_header_title}>
                {newsItem?.title}
              </Typography>
              <Typography component="p" className={styles.news_header_date}>
                {newsItem?.publishedDate}
              </Typography>
            </Box>
          </Box>

          <Box
            className={styles.news_body}
            sx={{
              '::-webkit-scrollbar': {
                width: '5px',
                height: '5px',
                backgroundColor: '#acacac'
              },
              '::-webkit-scrollbar-thumb': {
                backgroundColor: '#2b2d42',
                borderRadius: '5px'
              }
            }}>
            <div className={styles.sampleNewsLetter__container}>
              {data && createElement('div', { dangerouslySetInnerHTML: { __html: data } })}
            </div>
          </Box>

          <Box className={styles.bottom_navigation__container}>
            <Box className={styles.bottom_navigation__buttons}>
              <Button
                variant="outlined"
                endIcon={<MenuLeft />}
                disabled={previousIsDisabled}
                className={styles.bottom_navigation__button}
                onClick={handlePrevious}>
                Previous
              </Button>
              <Button
                variant="outlined"
                startIcon={<MenuRight />}
                disabled={nextIsDisabled}
                className={styles.bottom_navigation__button}
                onClick={handleForward}>
                Next
              </Button>
            </Box>
          </Box>
        </Stack>
      </Grow>
    </Modal>
  );
};

export default NewsModal;
